import { FormattedMessage } from 'react-intl';

type Props = {
  readonly type: 'SHORT' | 'LONG' | 'UNSUPPORTED';
};

const InvalidName = ({ type }: Props): JSX.Element | null => {
  switch (type) {
    case 'SHORT':
      return (
        <FormattedMessage
          id="account_v2.components.form_errors.invalid_name.short"
          defaultMessage="This seems too short. Please recheck it."
        />
      );

    case 'LONG':
      return (
        <FormattedMessage
          id="account_v2.components.form_errors.invalid_name.long"
          defaultMessage="Exceeds the 50 character max."
        />
      );

    case 'UNSUPPORTED':
      return (
        <FormattedMessage
          id="account_v2.components.form_errors.invalid_name.not_latin"
          defaultMessage="Please only use Latin characters."
          description="AL-1529; Screenshot: components.form_errors.invalid_name.not_latin.jpg"
        />
      );

    default:
      return null;
  }
};

export default InvalidName;
